import clsx from "clsx";
import { useSearchParams } from "react-router-dom";
import { useT } from "@app/contexts/preferences.context";
import { useState } from "react";
import { Order } from "@app/types";
import PhysicalTab from "./physical-tab";

type Tab = "physical" | "cloud";

/** Trang Thuê máy tính: 2 tab Máy vật lý / Cloud PC (tab lưu trên URL ?tab=cloud). */
function GpuHub() {
  const t = useT();
  const [params, setParams] = useSearchParams();
  const tab: Tab = params.get("tab") === "cloud" ? "cloud" : "physical";
  // tab Cloud PC mount ở lần mở đầu tiên rồi giữ lại (chỉ ẩn) như tab Máy vật lý
  const [cloudOpened, setCloudOpened] = useState(tab === "cloud");

  if (tab === "cloud" && !cloudOpened) setCloudOpened(true);

  const setTab = (next: Tab) => {
    setParams(next === "cloud" ? { tab: "cloud" } : {}, { replace: true });
  };

  // Máy đang thuê ở cả 2 tab hiện mọi máy: bấm "Tạo lại máy" ở máy thuộc loại kia thì chuyển sang tab đó và điền ở đó
  const [recreate, setRecreate] = useState<{ tab: Tab; order: Order; at: number }>();

  const recreateIn = (target: Tab) => (order: Order) => {
    setRecreate({ tab: target, order, at: Date.now() });
    setTab(target);
  };

  const tabs: [Tab, string][] = [
    ["physical", "Máy vật lý"],
    ["cloud", "Cloud PC"],
  ];

  return (
    <div className="flex flex-col gap-6 px-6 pb-12 pt-6 max-[1100px]:pb-24 max-[900px]:px-4 max-[760px]:gap-[18px]">
      {/* 2 nút tab nằm giữa: cột giữa của lưới 1fr|auto|1fr; ≤1240px tiêu đề 1 hàng, nút xuống hàng dưới và vẫn ở giữa */}
      <div className="grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-end gap-4 max-[1240px]:grid-cols-1">
        <div className="min-w-0">
          <h1 className="text-[26px] font-bold tracking-[-.015em] max-[760px]:text-[22px]">
            {t("Thuê Máy Tính")}
          </h1>
          <p className="m-0 mt-1 max-w-[62ch] text-muted">
            {t("Chọn loại máy, cấu hình và thời gian thuê. Máy sẽ được tạo ngay sau khi thanh toán.")}
          </p>
        </div>
        <div
          role="tablist"
          aria-label={t("Loại máy")}
          className="inline-flex justify-self-center rounded-[11px] border border-line bg-surface-2 p-1"
        >
          {tabs.map(([key, label]) => (
            <button
              key={key}
              type="button"
              role="tab"
              aria-selected={tab === key}
              onClick={() => setTab(key)}
              className={clsx(
                "flex items-center gap-2 rounded-lg px-[18px] py-[7px] font-semibold",
                tab === key ? "bg-surface text-fg shadow-card" : "text-muted"
              )}
            >
              {t(label)}
            </button>
          ))}
        </div>
      </div>

      {/* Giữ tab Máy vật lý luôn được mount (chỉ ẩn đi) để chuyển qua lại không phải tải lại và không bị nháy */}
      <div hidden={tab !== "physical"}>
        <PhysicalTab
          active={tab === "physical"}
          recreate={recreate?.tab === "physical" ? recreate : undefined}
          onRecreateOther={recreateIn("cloud")}
        />
      </div>
      {cloudOpened && (
        <div hidden={tab !== "cloud"}>
          <PhysicalTab
            cloudPc
            active={tab === "cloud"}
            recreate={recreate?.tab === "cloud" ? recreate : undefined}
            onRecreateOther={recreateIn("physical")}
          />
        </div>
      )}
    </div>
  );
}

export default GpuHub;
